import { TPlacementApplicationFormState } from 'shared/components/CoworkingPlacementApplicationForm';
import { IApplyForPublicationRequest } from 'shared/repositories/coworking/v1/apply-for-publication';

export function normalizePlacementApplicationFormFields(
  placementApplicationFormState: TPlacementApplicationFormState,
): IApplyForPublicationRequest {
  const { companyName, companyType, email, phone } = placementApplicationFormState;

  return {
    companyName: companyName.value,
    companyType: companyType.value,
    email: email.value,
    phone: phone.value,
  };
}
